import React from "react";
import { Box } from "@primer/react";
import { SyncIcon, DotFillIcon } from "@primer/octicons-react";

interface StatusIndicatorProps {
  hasProcessing: boolean;
  hasNewComplete: boolean;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  hasProcessing,
  hasNewComplete,
}) => {
  if (hasProcessing) {
    return (
      <Box
        sx={{
          position: "absolute",
          top: "-2px",
          right: "-2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "16px",
          height: "16px",
          color: "var(--fgColor-accent, #0969da)",
          pointerEvents: "none",
        }}
      >
        <SyncIcon size={12} className="anim-rotate" />
      </Box>
    );
  }
  if (hasNewComplete) {
    return (
      <Box
        sx={{
          position: "absolute",
          top: "-2px",
          right: "-2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "16px",
          height: "16px",
          color: "var(--fgColor-success, #1a7f37)",
          pointerEvents: "none",
        }}
      >
        <DotFillIcon size={12} />
      </Box>
    );
  }
  return null;
};
